import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';

export default function NotFound() {
  return (
    <article className="article-container text-[#221E1B] py-8">
      <SeoHead
        title="Siden blev ikke fundet – Radiatorproblemer.dk"
        description="Den efterspurgte side findes desværre ikke på Radiatorproblemer.dk. Find vejledninger om radiatorer på forsiden."
        canonicalPath="/404"
      />

      <div className="bg-[#F3E6DC] border border-[#E6DED5] rounded p-8 text-center space-y-4">
        <span className="font-mono text-3xl font-bold text-[#B5531E]">404</span>
        <h1 className="text-2xl font-bold text-[#221E1B] tracking-tight">
          Siden blev ikke fundet
        </h1>
        <p className="text-[17px] text-[#221E1B] leading-[1.65] max-w-lg mx-auto">
          Adressen du har indtastet, findes ikke på Radiatorproblemer.dk. Det kan skyldes en stavefejl i adressen eller et forældet link.
        </p>

        <div className="pt-4 flex flex-wrap items-center justify-center gap-4 text-sm font-medium">
          <Link
            to="/"
            className="text-[#B5531E] underline underline-offset-4 hover:text-[#221E1B]"
          >
            Gå til forsiden
          </Link>
          <span className="text-[#E6DED5]">·</span>
          <Link
            to="/radiator-varmer-ikke"
            className="text-[#B5531E] underline underline-offset-4 hover:text-[#221E1B]"
          >
            Radiatoren varmer ikke
          </Link>
          <span className="text-[#E6DED5]">·</span>
          <Link
            to="/udluftning-af-radiator"
            className="text-[#B5531E] underline underline-offset-4 hover:text-[#221E1B]"
          >
            Udluftning af radiator
          </Link>
          <span className="text-[#E6DED5]">·</span>
          <Link
            to="/ordbog"
            className="text-[#B5531E] underline underline-offset-4 hover:text-[#221E1B]"
          >
            VVS-ordbog
          </Link>
        </div>
      </div>
    </article>
  );
}
